<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{ version }}</span>
    <loading
      :active.sync="loadingSesion"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>

    <div>
      <div style="border: 1px solid #90d3dd; padding: 1%; border-radius: 15px">
        <div class="d-flex justify-content-between">
          <p class="text-left" style="color: #247baf; font-weight: 500">

            Tratamientos de la sesión
          </p>
          <div v-if="!bloquearAcciones">
            <em
                v-if="
              selectedTactuales.length == 0 ||
              (!sesionIniciada &&
                !$localStorageService.can('OG_tratamiento_sesion') &&
                loaderPasarTratsProg)
            "
                class="flecha_abajo_inactiva collapse_button"
                :title="
              sesionIniciada
                ? 'Primero selecciona un tratamiento'
                : msjIniciarSesion
            "
            ></em>

            <em
                v-else
                v-b-tooltip.hover
                :title="
              sesionIniciada
                ? 'Pasar a tratamientos programados'
                : msjIniciarSesion
            "
                @click="actualesToProgramados()"
                class="flecha_abajo_activa collapse_button"
            ></em>
          </div>

        </div>

        <b-table
          class="mt-4"
          style="min-height: 15vh"
          :filter="filterTrtsActuales"
          empty-filtered-text="Sin resultados"
          empty-text="Sin tratamientos en la sesión"
          show-empty
          ref="selectableTable"
          :isDraggable="true"
          selectable
          :select-mode="selectMode"
          :items="tratamientosActuales"
          :fields="filasTratamientos"
          @row-selected="onRowSelectedA"
          responsive
          sticky-header
        >
          <template #cell(nombreTratamiento)="row">
            <div class="d-flex text-center justify-content-center">
              <em v-if="row.item.nombreKit != null" v-b-tooltip.hover :title="row.item.nombreKit" class="tx_kit_svg" style="width: 3.5em;"></em>
              <p class="m-0">{{ row.item.nombreTratamiento}}</p>
            </div>
          </template>
          <template #cell(sesion)="row">
            <span>
                {{ row.item.numeroSesion+"/"+row.item.noMaxSesion }}
            </span>
          </template>
          <template #cell(precioOriginalSesion)="row">
              <span v-if="row.item.precioOriginalSesion">
                  {{ row.item.precioOriginalSesion | moneda }}
              </span>
            <span v-else>$0</span>
          </template>
          <template #cell(precioSesion)="row">
            <div>
              <span v-if="row.item.idTipoDescuentoPlan === 3" class="d-inline-flex align-items-center">
                {{ row.item.precioSesion | moneda }}
                <em class="info_outline" v-b-tooltip.hover :title="row.item.nombrePlan" style="width: 1.2em; margin-left: 4px;"></em>
              </span>
              <span v-else-if="row.item.precioSesion">
                  {{ row.item.precioSesion | moneda }}
                </span>
              <span v-else>$0</span>
              <div v-if="row.item.idTipoDescuentoPlan === 3" class="text-muted"
                   style="font-size: 0.60rem; margin-top: 2px;">
                <span v-if="row.item.precioSesion !== null">Co-pago fijo</span>
              </div>
            </div>
          </template>
          <template #cell(montoMinimo)="row">{{
            row.item.montoMinimo | moneda
          }}</template>
          <template #cell(montoDescuentoPlan)="row">
            <div class="text-center">
              <div v-if="(row.item.montoVale == null || row.item.montoVale == 0) && (row.item.montoDescuentoPlan != undefined && row.item.montoDescuentoPlan != null && row.item.montoDescuentoPlan > 0)">
                <div v-if="row.item.idTipoDescuentoPlan === 1">
                  <div class="d-flex justify-content-center align-items-center">
                    <span>{{ row.item.montoDescuentoPlan | moneda }}</span>
                    <em class="info_outline" v-b-tooltip.hover :title="row.item.nombrePlan" style="width: 1.2em; margin-left: 4px;"></em>
                  </div>
                  <div class="text-muted d-flex justify-content-center align-items-center" style="font-size: 0.70rem; margin-top: 2px;">
                    {{ row.item.descuento }}%
                  </div>
                </div>
                <div v-else-if="row.item.idTipoDescuentoPlan === 2">
                  <div class="d-flex justify-content-center align-items-center">
                    <span>{{ row.item.montoDescuentoPlan | moneda }}</span>
                    <em class="info_outline" v-b-tooltip.hover :title="row.item.nombrePlan" style="width: 1.2em; margin-left: 4px;"></em>
                  </div>
                  <div class="text-muted d-flex justify-content-center align-items-center" style="font-size: 0.60rem; margin-top: 2px;">
                    Monto descuento
                  </div>
                </div>
              </div>
              <span v-else>$0</span>
            </div>
          </template>
          <template #cell(montoVale)="row">
              <div v-if="row.item.montoVale != null && row.item.montoVale > 0">
                <span>
                  {{ row.item.montoVale | moneda }}
                </span>
                <em class="info_outline" v-b-tooltip.hover :title="row.item.nombreVale" style="width: 1.2em;"></em> 
              </div>
            <span v-else>$0</span>
          </template>
          <template #cell(montoPromocion)="row">
            <div v-if="row.item.montoPromocion > 0" class="d-flex justify-content-center align-items-center">
              <p class="m-0 p-0 mt-1 mr-1"> {{ row.item.montoPromocion | moneda }}</p>
              <em v-if="row.item.nombrePromocion != null" class="info_outline mr-1" v-b-tooltip.hover :title="row.item.nombrePromocion" style="width: 1.2em;"></em>
              <em v-if="!row.item.promocionForzosa && (row.item.saldoAFavor === 0 || row.item.saldoAFavor === null)" class="close_outline_svg" @click="guardarPromo(null, row.item)" style="width: 1.2em;" v-b-tooltip.hover title="Quitar promo aplicada"></em>
            </div>
            <div v-else class="d-flex justify-content-center align-items-center">
              <p class="m-0 p-0 mt-1 mr-1">$0</p>              
              <em v-if="!row.item.promocionForzosa && row.item.promociones !== null  && row.item.promociones.length > 0 && row.item.saldoAFavor === 0" class="etiqueta_promo" @click="logicaPromos(row.item)" v-b-tooltip.hover title="Aplicar promo"></em>
            </div>
          </template>
          <template #cell(montoCupon)="row">
              <span v-if="row.item.montoCupon">
                  {{ row.item.montoCupon | moneda }}
              </span>
            <span v-else>$0</span>
          </template>
          <template #cell(saldoAFavor)="row">
              <span v-if="row.item.saldoAFavor">
                  {{ row.item.saldoAFavor | moneda }}
              </span>
            <span v-else>$0</span>
          </template>
        </b-table>
      </div>

      <div
        class="mt-4"
        style="border: 1px solid #e4e4e4; padding: 1%; border-radius: 15px"
      >
        <div class="d-flex align-items-center" style="min-height: 5vh">
          <div class="d-flex justify-content-between align-items-center w-100">
            <p
              v-b-toggle.txProgramados
              class="text-left m-0"
              :class="{
                cardAbierta: isCollapseOpen,
                cardCerrada: !isCollapseOpen,
              }"
            >
              Tratamientos programados
            </p>
            <div class="d-flex" v-if="!bloquearAcciones">
              <em
                v-if="
                  selectedTprogramados.length == 0 ||
                  (!sesionIniciada &&
                    !$localStorageService.can('OG_tratamiento_sesion') &&
                    loaderPasarTratsAct)
                "
                class="flecha_arriba_inactiva collapse_button"
                :title="
                  sesionIniciada
                    ? 'Primero selecciona un tratamiento'
                    : msjIniciarSesion
                "
              ></em>
              <em
                v-else
                v-b-tooltip.hover
                :title="
                  sesionIniciada
                    ? 'Pasar a tratamientos de sesión'
                    : msjIniciarSesion
                "
                class="flecha_arriba_activa collapse_button"
                @click="programadosToActuales"
              ></em>
              <em class="chevron_gris m-3" v-b-toggle.txProgramados></em>
            </div>
          </div>
        </div>

        <b-collapse
          id="txProgramados"
          accordion="my-accordion"
          role="tabpanerel"
          @show="onShow"
          @hidden="onHide"
        >
          <b-table
            class="mt-4"
            :filter="filterTrtsProgramados"
            empty-filtered-text="Sin resultados"
            empty-text="Sin tratamientos programados"
            show-empty
            ref="selectableTable"
            selectable
            :select-mode="selectMode"
            :items="tratamientosProgramados"
            :fields="filasTratamientos"
            @row-selected="onRowSelectedP"
            responsive
            v-if="!loaderTratamientos"
            sticky-header
          >
          <template #cell(nombreTratamiento)="row">
            <div class="d-flex justify-content-center">
              <em v-if="row.item.nombreKit != null" v-b-tooltip.hover :title="row.item.nombreKit" class="tx_kit_svg" style="width: 3.5em;"></em>
              <p class="m-0">{{ row.item.nombreTratamiento}}</p>
            </div>
          </template>
          <template #cell(sesion)="row">
            <span>
                {{ row.item.numeroSesion+"/"+row.item.noMaxSesion }}
            </span>
          </template>
          <template #cell(precioOriginalSesion)="row">
              <span v-if="row.item.precioOriginalSesion">
                  {{ row.item.precioOriginalSesion | moneda }}
              </span>
              <span v-else>$0</span>
            </template>
            <template #cell(precioSesion)="row">
              <div>
                <span v-if="row.item.idTipoDescuentoPlan === 3" class="d-inline-flex align-items-center">
                  {{ row.item.precioSesion | moneda }}
                  <em class="info_outline" v-b-tooltip.hover :title="row.item.nombrePlan" style="width: 1.2em; margin-left: 4px;"></em>
                </span>
                <span v-else-if="row.item.precioSesion">
                  {{ row.item.precioSesion | moneda }}
                </span>
                <span v-else>$0</span>
                <div v-if="row.item.idTipoDescuentoPlan === 3" class="text-muted"
                     style="font-size: 0.60rem; margin-top: 2px;">
                  <span v-if="row.item.precioSesion !== null">Co-pago fijo</span>
                </div>
              </div>
            </template>
            <template #cell(montoMinimo)="row">{{
                row.item.montoMinimo | moneda
              }}</template>
            <template #cell(montoDescuentoPlan)="row">
              <div class="text-center">
                <div v-if="(row.item.montoVale == null || row.item.montoVale == 0) && (row.item.montoDescuentoPlan != undefined && row.item.montoDescuentoPlan != null && row.item.montoDescuentoPlan > 0)">
                  <div v-if="row.item.idTipoDescuentoPlan === 1">
                    <div class="d-flex justify-content-center align-items-center">
                      <span>{{ row.item.montoDescuentoPlan | moneda }}</span>
                      <em class="info_outline" v-b-tooltip.hover :title="row.item.nombrePlan" style="width: 1.2em; margin-left: 4px;"></em>
                    </div>
                    <div class="text-muted d-flex justify-content-center align-items-center" style="font-size: 0.70rem; margin-top: 2px;">
                      {{ row.item.descuento }}%
                    </div>
                  </div>
                  <div v-else-if="row.item.idTipoDescuentoPlan === 2">
                    <div class="d-flex justify-content-center align-items-center">
                      <span>{{ row.item.montoDescuentoPlan | moneda }}</span>
                      <em class="info_outline" v-b-tooltip.hover :title="row.item.nombrePlan" style="width: 1.2em; margin-left: 4px;"></em>
                    </div>
                    <div class="text-muted d-flex justify-content-center align-items-center" style="font-size: 0.60rem; margin-top: 2px;">
                      Monto descuento
                    </div>
                  </div>
                </div>
                <span v-else>$0</span>
              </div>
            </template>
            <template #cell(montoVale)="row">
              <div v-if="row.item.montoVale != null && row.item.montoVale > 0">
                <span>
                  {{ row.item.montoVale | moneda }}
                </span>
                <em class="info_outline" v-b-tooltip.hover :title="row.item.nombreVale" style="width: 1.2em;"></em>              
              </div>
            <span v-else>$0</span>
          </template>
            <template #cell(montoPromocion)="row">             
              <div v-if="row.item.montoPromocion" class="d-flex justify-content-center align-items-center">
              <p class="m-0 p-0 mt-1 mr-1"> {{ row.item.montoPromocion | moneda }}</p>
              <em v-if="row.item.nombrePromocion != null" class="info_outline" v-b-tooltip.hover :title="row.item.nombrePromocion" style="width: 1.2em;"></em>              
            </div>
            <div v-else class="d-flex justify-content-center align-items-center">
              <p class="m-0 p-0 mt-1 mr-1">$0</p>
            </div>
            </template>
            <template #cell(montoCupon)="row">
              <span v-if="row.item.montoCupon">
                  {{ row.item.montoCupon | moneda }}
              </span>
              <span v-else>$0</span>
            </template>
            <template #cell(saldoAFavor)="row">
              <span v-if="row.item.saldoAFavor">
                  {{ row.item.saldoAFavor | moneda }}
              </span>
              <span v-else>$0</span>
            </template>
          </b-table>
        </b-collapse>
      </div>
    </div>
    <RedireccionarAgenda v-if="!sesionIniciada" />
    <b-modal
      hide-footer
      title="Múltiples promociones"
      size="lg"
      id="modalPromociones"
      no-close-on-backdrop
      no-close-on-esc
      style="height: max-content !important;"
    >
    <p>Por favor selecciona la promoción que deseas aplicar</p>
        <div v-if="tratamientoSeleccionado != null" class="promo-container">
          <div class="promos-wrapper scrollable-container-promos">
            <div v-for="(promo, index) in tratamientoSeleccionado.promociones" 
                v-bind:key="index" 
                class="promo-box d-flex justify-content-between flex-column"
                :class="selectedPromo == index ? 'selected-promo' : 'default-promo'"
                @click="selectedPromo = index">
                
              <p v-if="index === 0" class="best-promo">¡Mejor promoción!</p>
              <p>{{ promo.nombrePromocion }}</p>
              <p class="mb-3">-{{ promo.montoPromocion | moneda }}</p>
              <p :class="{ 'label-promo': selectedPromo == index }" class="mt-5" >Total: {{ promo.precioSesionNuevoConPromocion | moneda }}</p>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center mt-3">
          <b-button class="mt-2 mr-4" @click="guardarPromo(selectedPromo, null)" variant="primary">Guardar</b-button>
          <b-button class="mt-2" @click="cerrarModalPromos()">Cancelar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import RedireccionarAgenda from "../../components/RedireccionarAgenda.vue";
import _ from "lodash";

export default {
  components: {
        RedireccionarAgenda,
  },
  props: {
    bloquearAcciones: Boolean,
  },
  name: "CardTratamientosSesion",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    selectedPromo: 0,
    tratamientosSeleccionados: [],
    loadingSesion: false,
    idPaciente: null,
    idEmpleado: null,
    sesionIniciada: true,
    msjIniciarSesion: "Inicia sesión para usar esta opción",
    filterTrtsActuales: null,
    filterTrtsProgramados: null,
    tratamientosActuales: [],
    selectedTactuales: [],
    selectedTprogramados: [],
    blnTratamientos: false,
    tratamientosProgramados: [],
    isCollapseOpen: false,
    filasTratamientos: [
      { key: "nombreTratamiento", label: "tratamiento" },
      { key: "sesion", label: "Sesión" },
      { key: "doctor", label: "Doctor" },
      { key: "numeroDiente", label: "OD" },
      { key: "precioOriginalSesion", label: "Precio original" },
      { key: "precioSesion", label: "Precio sesion" },
      { key: "montoDescuentoPlan", label: "Descuento plan" },
      { key: "montoVale", label: "Vale" },
      { key: "montoPromocion", label: "Descuento promo" },
      { key: "montoCupon", label: "Cupón" },
      { key: "precioSesion", label: "Inversión" },
      { key: "saldoAFavor", label: "Saldo abonado" },
    ],
    selectMode: "multi",
    loaderTratamientos: false,
    tratamientosClinica: [],
    loaderPasarTratsAct: false,
    loaderPasarTratsProg: false,
    tratamientoSeleccionado: null
  }),
  mounted() {
    this.idPaciente = +this.$route.params.idPaciente;
    this.idEmpleado = +this.$route.params.idDoctor;
    this.idSesion = +this.$route.params.idSesion;
    this.validarSesionActiva();
    this.refresh();
    this.$root.$on("refresh", () => {
      this.refresh();
    });
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();
    console.log('Bloquear acciones: ',this.bloquearAcciones);
    if (this.bloquearAcciones) {
      await this.showMensajeBloqueo();
    }
  },
  methods: {
    guardarPromo(indexPromo, tratamiento){
      var promoSeleccionada = null;
      if(indexPromo != null){
        promoSeleccionada = this.tratamientoSeleccionado.promociones[indexPromo];
      }

      var params = null;
      if(indexPromo != null){ //actualizar promo
        params = {
          idTratamientoProgramado: promoSeleccionada.idTratamientoProgramado, 
          idPromocion: promoSeleccionada.idPromocion,
          descuentoPromocion: promoSeleccionada.descuentoPromocion,
          montoPromocion: promoSeleccionada.montoPromocion,
          precioSesionNuevoConPromocion: promoSeleccionada.precioSesionNuevoConPromocion,
        };
      }else{ //eliminar promo
        params = {
          idTratamientoProgramado: tratamiento.idTratamientoProgramado, 
          idPromocion: 0,
          descuentoPromocion: null,
          montoPromocion: null,
          precioSesionNuevoConPromocion: 0,
          montoDescuentoPlan: tratamiento.montoDescuentoPlan,
          precioOriginalSesion: tratamiento.precioOriginalSesion
        };
      }

        this.$http
          .post(
            this.$api + "mejorDescuento/actualizarTrataProNuevaPromocion",
            params
          )
          .then((response) => {
            console.info(response);
            this.$swal({
              icon: "success",
              text: "Promo guardada correctamente",
              confirmButtonText: "De acuerdo",
              confirmButtonColor: "#0e6ba9",
            });
            this.obtenerTratamientosActuales();
            this.cerrarModalPromos();
          })
          .finally(() => {
            this.loadingSesion = false;
          });
    },

    cerrarModalPromos(){
      this.tratamientoSeleccionado = null;
      this.$bvModal.hide("modalPromociones");
    },
    logicaPromos(tratamiento){
      if(tratamiento.promociones && tratamiento.promociones.length > 1){
        this.tratamientoSeleccionado = tratamiento;
        this.$bvModal.show("modalPromociones");
      }else{
        this.tratamientoSeleccionado = tratamiento;
        this.guardarPromo(0, null);
      }
      
    },
    onShow() {
      this.isCollapseOpen = true;
    },
    onHide() {
      this.isCollapseOpen = false;
    },
    refresh() {
      this.obtenerTratamientosProgramados();
      this.obtenerTratamientosActuales();
    },
    async actulizarEstatusTratamiento(tratamiento, opcion) {
      tratamiento.opcion = opcion;
      tratamiento.idSesion = this.idSesion;
      tratamiento.idUsuario = this.$localStorageService.getIdUsuario();
      tratamiento.id = tratamiento.idTratamientoProgramado;
      return await this.$http
        .post(
          this.$api + "tratamiento_sesion/cambiarestatustratamiento",
          tratamiento
        )
        .then(async (response) => {
          if (response.data.data) {
            console.log("¡Datos guardados con éxito!")
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: response.data.message,
            });
          }
        })
        .catch(async (error) => {
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al crear el registro";
          await this.mostrarMensajeError(message);
        })
        .finally(async () => {
          //this.loadingSesion = false;
        });
    },
    async mostrarMensajeExito(mensaje) {
      return await this.$swal.fire({
        text: mensaje,
        icon: "success",
        confirmButtonText: "Ok",
        showLoaderOnConfirm: true,
      });
    },
    async mostrarMensajeError(mensaje) {
      this.$swal({
        icon: "error",
        text: mensaje,
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
      });
    },
    validarSesionActiva() {
      this.sesionIniciada = false;
      if (
        this.idEmpleado !== undefined &&
        this.idEmpleado !== null &&
        this.idEmpleado > 0
      ) {
        this.loadingSesion = true;
        const params = {
          idPaciente: this.$route.params.idPaciente,
          idEmpleado: this.idEmpleado,
        };
        this.$http
          .post(
            this.$api + "sesion/empleadoTieneSesionActivaPacienteEmpleado",
            params
          )
          .then((response) => {
            this.sesionIniciada = response.data.data;
            this.loadingSesion = false;
          })
          .finally(() => {
            this.loadingSesion = false;
          });
      }
    },
    onRowSelectedP(items) {
      this.selectedTprogramados = items;
    },
    async actualesToProgramados() {
      this.loaderPasarTratsAct = true;
      this.loadingSesion = true;
      await this.$http.post(this.$api + "lock/check/block", {idSesion: this.idSesion}).then(response => {
        let res = response.data.data;
        this.bloquearAcciones = res.fechaFinBloqueo !== null;
      });

      if (this.bloquearAcciones) {
       this.showMensajeBloqueo();
        return;
      }


      for (const item of this.selectedTactuales) {
        let index = this.tratamientosActuales.findIndex(
          (tratamiento) => tratamiento.id === item.id
        );
        this.tratamientosActuales.splice(index, 1);
        await this.actulizarEstatusTratamiento(item, 2);
      }
      await this.obtenerTratamientosActuales();
      await this.obtenerTratamientosProgramados();
      this.loaderPasarTratsProg = false;
      this.loadingSesion = false;
      await this.mostrarMensajeExito("¡Datos guardados con éxito!");
      console.info("-------------************terminado0");
    },
    async programadosToActuales() {
      this.loaderPasarTratsAct = true;
      this.loadingSesion = true;
      await this.$http.post(this.$api + "lock/check/block", {idSesion: this.idSesion}).then(response => {
        let res = response.data.data;
        this.bloquearAcciones = res.fechaFinBloqueo !== null;
      });

      if (this.bloquearAcciones) {
        this.showMensajeBloqueo();
        return;
      }

      this.tratamientosSeleccionados = this.selectedTprogramados.map((item) => {
        return item;
      });
      for (const item of this.selectedTprogramados) {
        if (this.tratamientosSeleccionados.length == 0) {
          break;
        }
        let index = this.tratamientosProgramados.findIndex(
            (tratamiento) => tratamiento.id === item.id
        );
        this.tratamientosProgramados.splice(index, 1);

        await this.verificarNumeroSesiones(item);
        if (item.consentimiento != null || item.consentimiento != undefined) {
          await this.mostrarMensajeExito(
            "Consentimientos informados generados!"
          );
        }
      }
      await this.obtenerTratamientosActuales();
      await this.obtenerTratamientosProgramados();
      this.loaderPasarTratsProg = false;
      this.loadingSesion = false;
      await this.mostrarMensajeExito("¡Datos guardados con éxito!");
    },
    onRowSelectedA(items) {
      this.selectedTactuales = items;
    },
    async obtenerTratamientosProgramados() {
      this.loaderTratamientos = true;
      this.loadingSesion = true;
      const parametros = {
        idPaciente: this.idPaciente,
        isPantallaSesion: true,
      };
      await this.$http
        .post(this.$api + "tratamiento_sesion/listadotratamientos", parametros)
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            this.tratamientosProgramados = resultado;

            this.tratamientosProgramados = _.orderBy(
              this.tratamientosProgramados,
              ["tratamiento"],
              ["asc"]
            );
            this.tratamientosProgramados = this.tratamientosProgramados.filter(
              (trt) => trt.idEmpleado === this.idEmpleado
            );

            this.loaderTratamientos = false;
            this.blnTratamientos = resultado.length;
            this.loadingSesion = false; 
          }
        })
        .catch(function () {
          this.loaderTratamientos = false;
        });
    },
    async obtenerTratamientosActuales() {
      this.loadingSesion = true;
      const parametros = {
        idPaciente: this.idPaciente,
        idSesion: this.idSesion,
      };
      await this.$http
        .post(
          this.$api + "tratamiento_sesion/listadotratamientosactualesSesion",
          parametros
        )
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            this.tratamientosActuales = resultado;
          
            this.tratamientosActuales = _.orderBy(
              this.tratamientosActuales,
              ["tratamiento"],
              ["asc"]
            );
            this.tratamientosActuales = this.tratamientosActuales.filter(
              (trt) => trt.idEmpleado === this.idEmpleado
            );
            this.blnActuales = resultado.length;
          }
        })
        .catch(function (error) {
          this.loadingSesion = false;
          console.error(error);
        });
    },
    async verificarNumeroSesiones(item) {
      return await new Promise(async (resolve) => {
        if (item.noMaxSesion === 1) {
          await this.guardarUltimaSesion(item).then(() => {
            resolve();
          });
        } else if (item.noMaxSesion >= 2 && item.ses >= 2) {
          var mensajeSwal = "";
          if (item.od !== null) {
            mensajeSwal = ". OD: " + item.od + ". No. sesión: " + item.ses;
          } else {
            mensajeSwal = ". No. sesión: " + item.ses;
          }
          await this.$swal
            .fire({
              title:
                "¿Es la última sesión del tratamiento " +
                item.tratamiento.toLowerCase() +
                mensajeSwal +
                "? No se puede revertir la acción.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Sí",
              cancelButtonText: "No",
              showLoaderOnConfirm: true,
            })
            .then(async (result) => {
              if (result.isConfirmed) {
                await this.guardarUltimaSesion(item).then(() => {
                  resolve();
                });
              } else {
                await this.cambioProgramadosToActuales(item).then(() => {
                  resolve();
                });
              }
            });
        } else {
          await this.cambioProgramadosToActuales(item).then(() => {
            resolve();
          });
        }
      });
    },
    async guardarUltimaSesion(item) {
      const datos = {
        idTratamientoProgramado: item.idTratamientoProgramado
      }
      return await this.$http
        .post(this.$api + "tratamiento_sesion/guardar/ultimaSesion", datos)
        .then(async (response) => {
          if (response.data.data) {
            return await this.cambioProgramadosToActuales(item).then(
              async () => {
                if (item.noMaxSesion >= 2) {
                  for (var i = item.ses + 1; i <= item.noMaxSesion; i++) {
                    var tratamientoR = this.tratamientosProgramados.find(
                      (tratamiento) => {
                        return (
                          tratamiento.noTratamiento === item.noTratamiento &&
                          tratamiento.od === item.od &&
                          tratamiento.ses === i
                        );
                      }
                    );

                    await this.cambioProgramadosToActuales(tratamientoR);
                  }

                  for (var j = item.ses - 1; j >= 2; j--) {
                    var tratamiento2 = this.tratamientosProgramados.filter(
                      (tratamiento) => {
                        return (
                          tratamiento.noTratamiento === item.noTratamiento &&
                          tratamiento.od === item.od &&
                          tratamiento.ses === j
                        );
                      }
                    );

                    await this.cambioProgramadosToActuales(tratamiento2[0]);
                  }
                }
              }
            );
          }
        })
        .catch(() => {});
    },
    async cambioProgramadosToActuales(item) {
      if (
        item.presupuestoHistorico != null &&
        item.presupuestoHistorico === true
      ) {
        return await this.$swal
          .fire({
            title:
              "¿Desea actualizar los precios del tratamiento " +
              item.tratamiento.toLowerCase() +
              "?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí",
            cancelButtonText: "No",
            showLoaderOnConfirm: true,
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              const parametros = {
                idTratamientoProgramado: item.id,
                idSesion: this.idSesion,
              };
              //Se manda a llamar servicio que genere los nuevos precios
              return await this.$http
                .put(
                  this.$api +
                    "tratamiento_sesion/actualizar/precio/tratamientoprogramado",
                  parametros
                )
                .then(async (response) => {
                  if (response.data.data) {
                    let resultado = response.data.data;
                    await this.actulizarEstatusTratamiento(resultado, 1);

                    let index = this.tratamientosProgramados.findIndex(
                      (tratamiento) => tratamiento.id === item.id
                    );
                    this.tratamientosProgramados.splice(index, 1);

                    let index2 = this.tratamientosSeleccionados.findIndex(
                      (tratamiento) => tratamiento.id === item.id
                    );
                    this.tratamientosSeleccionados.splice(index2, 1);
                  }
                })
                .catch(() => {});
            } else {
              // TODO ! PENDIENTE
              let index = this.tratamientosProgramados.findIndex(
                (tratamiento) => tratamiento.id === item.id
              );
              this.tratamientosProgramados.splice(index, 1);

              let index2 = this.tratamientosSeleccionados.findIndex(
                (tratamiento) => tratamiento.id === item.id
              );
              this.tratamientosSeleccionados.splice(index2, 1);

              await this.actulizarEstatusTratamiento(item, 1);
            }
          });
      } else {
        let index = this.tratamientosProgramados.findIndex(
          (tratamiento) => tratamiento.id === item.id
        );

        let index2 = this.tratamientosSeleccionados.findIndex(
          (tratamiento) => tratamiento.id === item.id
        );
        this.tratamientosSeleccionados.splice(index2, 1);

        this.tratamientosProgramados.splice(index, 1);
        return this.actulizarEstatusTratamiento(item, 1);
      }
    },

    showMensajeBloqueo(){
      this.$swal.fire({
        icon: "warning",
        title: "Aviso",
        text: "Ya se encuentra un proceso de caja actualmente",
      })
    }
  },
};
</script>

<style scoped>
.promo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 25vh;
  margin-top: 7%;
}

.promos-wrapper {
  display: flex;
  flex-wrap: wrap; 
  gap: 20px; 
  position: relative; 
  justify-content: center;
}

.promo-box {
  position: relative;
  padding: 15px;
  border-radius: 10px;
  border: 2px solid #ccc;
  text-align: center;
  width: 220px; 
  word-break: break-word; 
  white-space: normal;   
  overflow-wrap: break-word; 
}

.best-promo {
  position: absolute;
  top: -25px; 
  left: 50%;
  transform: translateX(-50%); 
  font-weight: bold;
  color: #247BAF;
  white-space: nowrap;
}

.label-promo {
  font-weight: bold;
  color: #247BAF;
  font-size: 1em;
}
.scrollable-container-promos{
  overflow-y: auto; 
  max-height: 40em; 
}

.selected-promo{
  border: 1px solid #90D3DD;
  border-radius: 15px;  
  box-shadow: 0px 0px 4.3px 0px rgba(0, 0, 0, 0.25);
  min-height: 10vh;
}

.default-promo{
  border: 1px solid #dadada;
  border-radius: 15px;  
  min-height: 10vh;
}

.cardAbierta {
  font-weight: 500;
}

.cardCerrada {
  color: #9b9b9b;
}

.collapse_button{
  width: 1.4em;
  cursor: pointer;
}
</style>
